import { jsxs as M, jsx as O } from "react/jsx-runtime";
import { createContext as x, useState as n, useCallback as a, useContext as h } from "react";
import { Modal as w } from "./components.js";
const b = {
  showModal: () => {
  },
  closeModal: () => {
  },
  updateOptions: () => {
  }
}, c = x(b), r = {
  title: void 0,
  children: void 0,
  onClose: void 0,
  preventClose: !1,
  style: void 0,
  bannerImage: void 0
};
function S({ children: p }) {
  const [u, l] = n(!1), [v, d] = n(0), [t, e] = n(r), f = a(
    (o, s) => {
      l(!0), e((m) => ({
        ...m,
        ...s,
        children: o
      })), d(Date.now());
    },
    []
  ), i = a(() => {
    var o;
    (o = t.onClose) == null || o.call(t), l(!1), e(r);
  }, [v]), C = a((o) => {
    e((s) => ({
      ...s,
      ...o
    })), d(Date.now());
  }, []);
  return /* @__PURE__ */ M(
    c.Provider,
    {
      value: {
        showModal: f,
        closeModal: i,
        updateOptions: C
      },
      children: [
        p,
        u && /* @__PURE__ */ O(w, { ...t, onClose: i })
      ]
    }
  );
}
const U = () => h(c);
export {
  S as ModalProvider,
  U as useModal
};
